import React from 'react';

interface IHeaderCmpProps {
    title: React.ReactNode;
    rightSideContent?: React.ReactNode;
    leftSideContent?: React.ReactNode;
    parentClassName?: string;
    isHeaderWithBg?: boolean;
}

const HeaderCmp = ({ title, rightSideContent, leftSideContent, parentClassName = '', isHeaderWithBg = false }: IHeaderCmpProps) => (
    <div className={`table-top-header rounded-t-[inherit] ${isHeaderWithBg ? 'bg-gray25' : 'bg-white'} ${parentClassName}`}>
        <div className="table-left-wrap">
            <div className={`table-title-wrap`}>
                {title && <h5 className="table-title">{title}</h5>}
                {leftSideContent ? leftSideContent : <></>}
            </div>
        </div>
        {rightSideContent ? rightSideContent : <></>}
    </div>
);

export default HeaderCmp;
